import React from "react"

import RatingByLine from "components/common/rating-by-line"
import { Card, Text, Attribution, Product, ProductImage } from "./styles"

const TestimonialCard = ({
  product,
  rating,
  text,
  attribName,
  attribTitle,
  variant,
  dataId,
  hideOnPageLoad,
  ...props
}) => (
  <Card hideOnPageLoad={hideOnPageLoad} data-exp-id={dataId} {...props}>
    {product && (
      <Product>
        <ProductImage
          baseUrl={product.image}
          images={[{ transforms: "c_fill,g_auto,w_48,h_48,q_auto,f_auto,fl_lossy" }]}
        />
        <div>
          <h4>{product.title}</h4>
          <h5>{product.subtitle}</h5>
        </div>
      </Product>
    )}
    {rating && <RatingByLine style={{ marginTop: "2rem" }} rating={rating} hideCount />}
    <Text dangerouslySetInnerHTML={{ __html: text }} />
    <Attribution>
      {variant === "mini" && <span className="attribSmall">&mdash;&nbsp;{attribName}</span>}
      {variant !== "mini" && (
        <span>
          {attribName}
          <br />
          <span className="attribSmall">{attribTitle}</span>
        </span>
      )}
    </Attribution>
  </Card>
)

export default TestimonialCard
